import { makeStyles } from "@material-ui/core"

import colors from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(3)
	},
	link: {
		fontWeight: "bold",
		display: "block",
		flex: 1,
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	arrowIndicator: {
		transform: "rotate(90deg)",
		color: colors.greyScale[3]
	},
	copyButton: {
		color: colors.greyScale[3]
	},
	headerContent: {
		flex: 1,
		transform: "translateY(18px)"
	},
	linkContainer: {
		flex: 1
	},
	isAdminMode: {
		zIndex: 9999,
		position: "fixed",
		bottom: 0,
		left: 0,
		margin: "0 auto",

		background: "#F1C34E",
		color: colors.greyScale[11],
		fontWeight: "bold",
		textTransform: "uppercase",

		fontSize: "14px",
		lineHeight: "19px",

		padding: theme.spacing(0.5, 2)
	}
}))

export default useStyles
